import AccountBillingHistory from "../../components/AccountSettings/BillingHistory";
import AccountProfileScreen from "../../components/AccountSettings/Profile";
import ManageAccountSubscriptions from "../../components/AccountSettings/Subscriptions";


const settingsRoutes = [
  {
    path: "",
    Component: <AccountProfileScreen />,
    title: "Edit Profile",
  },
  {
    path: "subscriptions",
    Component: <ManageAccountSubscriptions />,
    title: "Subscriptions",
  },
  {
    path: "billing-history",
    Component: <AccountBillingHistory />,
    title: "Billing History",
  },
  {
    path: "payment-methods",
    Component: <AccountBillingHistory />,
    title: "Payment Methods",
  },
];

export default settingsRoutes;
